import { MapStationInfo } from '@openlayers/MapStationInfo';
import { mapUI, mapWrapper } from '@pages/map/map';
import { ModelsSurfaceHeightAtLocation } from '@shared/map/ModelsSurfaceHeightAtLocation';
import { Events } from '@shared/Events';
import { LStorage } from '@shared/Storage';
import { CollapsiblePanel } from '@shared/ui-react/CollapsiblePanel';
import { makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { transform as olTransform } from 'ol/proj';
import { ModelsSurfaceProps } from '@shared/map/ModelsSurfaceProps';
import * as React from 'react';
import './StationAndModelInfoBoxDesktop.scss';


@observer
export class StationAndModelInfoBoxDesktop extends React.Component {
    @observable stationInfo: StationCoords = null;
    @observable modelIds = [];
    @observable lat = 0;
    @observable lon = 0;
    @observable modelInfo: IModelPropsInfo = {
        id: null,
        name: null,
        props: null,
        isStructure: false,
    };
    @observable showHeights = LStorage.getOrDefault('map__station-box__show-heights', true);
    @observable showProperties = LStorage.getOrDefault('map__station-box__show-props', true);
    @observable psetsCollapsibleMap = new Map();

    constructor(props) {
        super(props);
        makeObservable(this);

        Events.on('mapStationAdded', (e, data) => this.stationInfo = data.measure);
        Events.on('mapStationRemoved', () => this.stationInfo = null);
    }

    componentDidMount() {
        Events.on('mapClickMarker:update', this.onUpdateMarker);
        Events.on('mapClickModel', this.onUpdateModel);
        mapWrapper.featureLayers.models.layerSource.on('addfeature', this.onUpdateMarker);
        mapWrapper.featureLayers.models.layerSource.on('removefeature', this.onUpdateMarker); // never fires because of perf optimization, see LayerWrapper
        this.onUpdateMarker();
    }

    onUpdateModel = _.debounce((evt, data) => runInAction(() => {
        this.modelInfo.id = parseInt(data.id);
        this.modelInfo.name = data.name;
        this.modelInfo.props = data.props;
        this.modelInfo.isStructure = data.isStructure;
    }), 100);

    onUpdateMarker = _.debounce(() => runInAction(() => {
        if (mapWrapper.clickMarkerLayer.clickMarkerPosition) {
            const [lon, lat] = olTransform(mapWrapper.clickMarkerLayer.clickMarkerPosition, 'EPSG:3857', 'EPSG:4326');
            this.lat = lat;
            this.lon = lon;
        }
        else {
            this.lat = 0;
            this.lon = 0;
        }

        this.modelIds = mapUI.mapPanels.panels.models.getCheckedFileIds();

        if (this.modelInfo.id) {
            if (!this.modelIds.includes(this.modelInfo.id)) {
                this.modelInfo = {
                    id: null,
                    name: null,
                    props: null,
                    isStructure: false,
                };
            }
        }
    }), 300);

    render() {
        return (<>
                <section>
                    <MapStationInfo stationInfo={this.stationInfo} />
                </section>

                <CollapsiblePanel label={__('js_map.surface_elevation_and_area')} defaultIsOpen={true} animated={false} lazyLoad={true}  isOpen={this.showHeights} onToggle={this.toggleShowHeights}>
                    <ModelsSurfaceHeightAtLocation lat={this.lat} lon={this.lon} modelIds={this.modelIds} />
                </CollapsiblePanel>

                <CollapsiblePanel label={__('js_map.surface_properties')} defaultIsOpen={true} animated={false} lazyLoad={true} isOpen={this.showProperties} onToggle={this.toggleShowProperties}>
                    <ModelsSurfaceProps modelInfo={this.modelInfo}/>
                </CollapsiblePanel>
            </>
        );
    }

    toggleShowHeights = state => {
        this.showHeights = state;
        LStorage.setItem('map__station-box__show-heights', this.showHeights);
    };

    toggleShowProperties = state => {
        this.showProperties = state;
        LStorage.setItem('map__station-box__show-props', this.showProperties);
        LStorage.setItem('map__station-box__show-props', this.showProperties);
    };
}

